import { useQuery, keepPreviousData } from '@tanstack/react-query';

import {
  queryFn,
  USER_PORTFOLIOS_QUERY_KEY,
  userPortfoliosSelector,
} from './queryFn';

type Response = ReturnType<typeof userPortfoliosSelector> & {
  isFetched: boolean;
  isFetching: boolean;
};
export type Portfolio = Response['entities'][string];

export function useDeprecatedUserPortfolios(): Response {
  const {
    isFetched,
    isFetching,
    data = {
      keys: [],
      entities: {},
      canCreatePortfolio: false,
      totalHoldingsCount: 0,
    },
  } = useQuery({
    queryKey: USER_PORTFOLIOS_QUERY_KEY,
    queryFn,
    staleTime: Infinity,
    refetchOnMount: true,
    placeholderData: keepPreviousData,
    select: userPortfoliosSelector,
  });

  return {
    ...data,
    isFetched,
    isFetching,
  };
}
